export default __webpack_public_path__ + "cee623fcab0945207de88a3c8de44672.jpeg";